import React, { useEffect, useRef } from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import './results-section.css';

const ResultsSection = () => {
  const { t } = useLanguage();
  const sectionRef = useRef(null);
  const animated = useRef(false);

  useEffect(() => {
    const timers = [];

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !animated.current) {
            animated.current = true;
            const counters = entry.target.querySelectorAll('[data-count]');
            counters.forEach((counter) => {
              const target = parseInt(counter.getAttribute('data-count'), 10);
              const duration = 1800;
              const stepTime = 16;
              const steps = duration / stepTime;
              const increment = target / steps;
              let current = 0;
              const timer = setInterval(() => {
                current += increment;
                if (current >= target) {
                  counter.textContent = target;
                  clearInterval(timer);
                } else {
                  counter.textContent = Math.floor(current);
                }
              }, stepTime);
              timers.push(timer);
            });
          }
        });
      },
      { threshold: 0.3 }
    );

    const node = sectionRef.current;
    if (node) observer.observe(node);
    return () => {
      if (node) observer.disconnect();
      timers.forEach(clearInterval);
    };
  }, []);

  return (
    <section className="results-section section-padding" id="results" ref={sectionRef}>
      <div className="container">
        <div className="results-section-header">
          <span className="section-label">{t.results.label}</span>
          <h2 className="results-section-heading">{t.results.title}</h2>
        </div>
        <div className="results-grid">
          {(t.results?.stats ?? []).map((stat, index) => (
            <div className="result-item" key={index}>
              <h3>
                <span className="result-number" data-count={stat.value}>{stat.value}</span>
                <span className="result-suffix">{stat.suffix}</span>
              </h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
        <p className="results-context">{t.results.context}</p>
      </div>
    </section>
  );
};

export default ResultsSection;
